import { render, staticRenderFns } from "./personalDgreeInfo.vue?vue&type=template&id=1fa0b5a1&scoped=true&"
import script from "./personalDgreeInfo.vue?vue&type=script&lang=js&"
export * from "./personalDgreeInfo.vue?vue&type=script&lang=js&"
import style0 from "./personalDgreeInfo.vue?vue&type=style&index=0&id=1fa0b5a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa0b5a1",
  null
  
)

export default component.exports